app.factory('ewusService', ['$q', 'baseService', 'objectHelper', 'config',
    function($q, baseService, objectHelper, config) {

        function EWUSService() {

            this.updateRefundStatusForVisit = function(id) {
                return baseService.post(config.API_URL + '/ewus/updateRefundStatusForVisit/' + id).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, VisitVO);
                        data = objectHelper.convertTimesToDates(data);

                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.updateEwusAuthenticationDataForDoctor = function(id, authData) {
                return baseService.post(config.API_URL + '/ewus/updateEwusAuthenticationDataForDoctor/' + id, authData).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, EwusAuthenticationDataWrapper);

                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getEwusAuthenticationDataForDoctor = function(id) {
                return baseService.get(config.API_URL + '/ewus/getEwusAuthenticationDataForDoctor/' + id).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, EwusAuthenticationDataWrapper);

                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

        }

        return new EWUSService();
    }
]);
